import styled from '@emotion/styled'

import { colors, Text } from 'main/ui'

export const ErrorText = styled(Text)`
  color: ${colors.text.error};
`
